import React, { useState, useRef, useEffect } from "react";
import { FaGlobe } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const GlobeSelector = () => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("EN");
  const navigate = useNavigate();
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const regions = [
    { flag: "🌍", label: "Global – English", code: "EN", path: "/" },
    { flag: "🇮🇳", label: "India – English", code: "IN", path: "/in" },
    { flag: "🇺🇸", label: "North America – English", code: "US", path: "/us" },
    { flag: "🇯🇵", label: "Japan – 日本語", code: "JP", path: "/jp" },
    { flag: "🇪🇺", label: "Europe – English", code: "EU", path: "/eu" },
  ];

  const handleSelect = (item) => {
    setSelected(item.code);
    setOpen(false);
    navigate(item.path);
  };

  return (
    <div ref={wrapperRef} className="relative inline-block text-sm">
      {/* Button */}
      <button
        onClick={() => setOpen(!open)}
        className="
          flex items-center gap-2 px-3 py-1.5 
          bg-white border border-gray-300 rounded-md
          text-gray-900 font-medium 
          hover:bg-gray-100 transition-all duration-200
        "
      >
        <FaGlobe className="text-gray-700" />
        <span className="font-semibold">({selected})</span>
      </button>

      {/* Dropdown */}
      {open && (
        <ul
          className="
            absolute left-0 md:left-auto md:right-0 mt-2 w-64 
            bg-white text-gray-900 
            rounded-xl shadow-lg border border-gray-200 
            overflow-hidden z-50 animate-fadeIn
          "
        >
          <li className="px-4 py-2.5 font-semibold text-gray-700 bg-gray-50 border-b border-gray-200">
            🌐 Select Region & Language
          </li>

          {regions.map((item, index) => (
            <li
              key={index}
              onClick={() => handleSelect(item)}
              className="
                flex items-center gap-3 px-4 py-3 cursor-pointer
                hover:bg-[#70be44]/10 hover:text-[#70be44]
                transition-all duration-200
              "
            >
              <span className="text-lg">{item.flag}</span>
              <span>{item.label}</span>
            </li>
          ))}
        </ul>
      )}

      {/* Animation Style */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(6px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fadeIn {
            animation: fadeIn 0.18s ease-out;
          }
        `}
      </style>
    </div>
  );
};

export default GlobeSelector;
